// extracted by mini-css-extract-plugin
module.exports = {"tab-button":"tab-button-28YARlG","selected":"selected-32Bvkqs","file-tab-button":"file-tab-button-1H8hIvI"};